// src/web/pages/allBookListWeb.jsx
import React from 'react';
import usePublicQueue from '../../shared/hooks/usePublicQueue';
import PublicQueueList from '../../shared/components/PublicQueueList';
import LoadingCard from '../../shared/components/LoadingCard';
import ClosedCard from '../../shared/components/ClosedCard';

// ※ PublicQueueList が使う .line-* クラスを再利用
import '../../line/styles/line.css';
import '../styles/all-web.css';  

export default function AllBookListWeb() {
  // Web は誰でも閲覧可なので userId は常に null
  const queue = usePublicQueue({
    userId: null,
    userIdField: 'lineId',  // 予約ドキュメントのユーザー識別フィールド
    enabled: true,          // 常に購読
  });

  // 読み込み条件：runtimeが未確定、または受付ONでrows未到着
  const loading =
    !queue.runtimeReady ||
    (queue.inhouseOn === true && !queue.rowsReady);

  if (loading) {
    return (
      <div className="line-container">
        <LoadingCard />
      </div>
    );
  }

  // 受付OFFは “停止中” を表示（文言はお好みで）
  if (queue.inhouseOn === false) {
    return (
      <div className="line-container">
        <ClosedCard
          title="現在、院内受付は停止中です"
          description="受付再開までしばらくお待ちください。"
        />
      </div>
    );
  }

  // 一覧（“あなた”バッジはWebでは出さない）
  return (
    <div className="queue-skin--web">
        <PublicQueueList
        inhouseOn={queue.inhouseOn}
        waitCount={queue.waitCount}
        nowStr={queue.nowStr}
        list={queue.list}
        myAheadCount={null}
        showMineBadge={false}
        />
        {/* 予約ボタン（同画面遷移） */}
      <div className="line-all-footer-actions">
        <a
          href="https://line.me/R/home/public/profile?id=404rczrt"
          className="line-all-footer-btn"
          aria-label="LINE公式アカウントの予約ページへ"
        >
          ご予約はこちらから
        </a>
      </div>
    </div>
  );
}
